export enum TemplateSearchOrder {
  OrderByTemplateId = 1,
  OrderByName = 2,
  OrderByDescription = 3,
  OrderByModifyDateTime = 4,
}
